/* Swamp Cracker redesign: product page gallery and variant form.
   The form posts natively to /cart/add, so the cart owner (AMP Slide Cart,
   else Shopify's cart page) handles the add exactly as on other templates. */
(function () {
  'use strict';

  /* Main image + thumbnails. Listens for sc:media from the form so variant
     changes show the variant's image. */
  class ScProductGallery extends HTMLElement {
    connectedCallback() {
      this.onClick = (event) => {
        var thumb = event.target.closest('[data-thumb]');
        if (thumb) this.show(thumb.dataset.thumb);
      };
      this.onMedia = (event) => {
        if (event.detail && event.detail.section === this.dataset.section && event.detail.mediaId) {
          this.show(String(event.detail.mediaId));
        }
      };
      this.addEventListener('click', this.onClick);
      document.addEventListener('sc:media', this.onMedia);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      document.removeEventListener('sc:media', this.onMedia);
    }

    show(mediaId) {
      var target = this.querySelector('[data-media-id="' + mediaId + '"]');
      if (!target) return;
      this.querySelectorAll('[data-media-id]').forEach((slide) => {
        slide.hidden = slide !== target;
      });
      this.querySelectorAll('[data-thumb]').forEach((thumb) => {
        if (thumb.dataset.thumb === mediaId) {
          thumb.setAttribute('aria-current', 'true');
          thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
    }
  }

  class ScProductForm extends HTMLElement {
    connectedCallback() {
      var data = this.querySelector('[data-variants]');
      this.variants = data ? JSON.parse(data.textContent) : [];
      this.form = this.querySelector('form');
      this.idInput = this.querySelector('[data-variant-id]');
      this.atc = this.querySelector('[data-atc]');
      this.atcLabel = this.querySelector('[data-atc-label]');
      this.status = this.querySelector('[data-variant-status]');
      this.qty = this.querySelector('[data-qty-input]');
      this.section = this.closest('[data-section-id]');

      this.onChange = (event) => {
        if (event.target.matches('.sc-pdp__radio')) this.update();
      };
      this.onClick = (event) => {
        var step = event.target.closest('[data-qty-step]');
        if (!step || !this.qty) return;
        var next = Math.max(1, (parseInt(this.qty.value, 10) || 1) + Number(step.dataset.qtyStep));
        this.qty.value = next;
      };
      this.addEventListener('change', this.onChange);
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('click', this.onClick);
    }

    selectedOptions() {
      return Array.from(this.querySelectorAll('[data-option-index]')).map((fieldset) => {
        var checked = fieldset.querySelector('.sc-pdp__radio:checked');
        var label = fieldset.querySelector('[data-option-selected]');
        if (checked && label) label.textContent = checked.value;
        return checked ? checked.value : null;
      });
    }

    update() {
      var options = this.selectedOptions();
      var variant = this.variants.find((v) => v.options.every((value, i) => value === options[i]));
      this.markAvailability(options);

      if (!variant) {
        this.setButton(false, this.dataset.labelUnavailable);
        this.announce(this.dataset.labelUnavailable);
        return;
      }

      this.idInput.value = variant.id;
      this.setPrice(variant);
      this.setButton(variant.available, variant.available ? null : this.dataset.labelSoldout, variant.price);
      this.announce(options.join(' / ') + ', ' + variant.price + (variant.available ? '' : ', ' + this.dataset.labelSoldout));

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      if (variant.media) {
        document.dispatchEvent(new CustomEvent('sc:media', { detail: { section: this.dataset.section, mediaId: variant.media } }));
      }
    }

    /* For each value, show whether it can be bought with the other selections. */
    markAvailability(options) {
      this.querySelectorAll('[data-option-index]').forEach((fieldset) => {
        var index = Number(fieldset.dataset.optionIndex);
        fieldset.querySelectorAll('.sc-pdp__radio').forEach((radio) => {
          var candidate = options.slice();
          candidate[index] = radio.value;
          var match = this.variants.find((v) => v.options.every((value, i) => value === candidate[i]));
          var label = fieldset.querySelector('label[for="' + radio.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }

    setPrice(variant) {
      if (!this.section) return;
      var price = this.section.querySelector('[data-price]');
      var compare = this.section.querySelector('[data-compare]');
      var compareValue = this.section.querySelector('[data-compare-value]');
      if (price) price.textContent = variant.price;
      if (compare) {
        compare.hidden = !variant.compare;
        if (variant.compare && compareValue) compareValue.textContent = variant.compare;
      }
    }

    setButton(available, text, price) {
      this.atc.disabled = !available;
      if (available) {
        this.atcLabel.innerHTML = '';
        this.atcLabel.append(this.dataset.labelAdd);
        var sep = document.createElement('span');
        sep.className = 'sc-pdp__atc-sep';
        sep.setAttribute('aria-hidden', 'true');
        sep.textContent = '  /  ';
        var amount = document.createElement('span');
        amount.className = 'sc-pdp__atc-price';
        amount.textContent = price;
        this.atcLabel.append(sep, amount);
      } else {
        this.atcLabel.textContent = text;
      }
    }

    announce(text) {
      if (this.status) this.status.textContent = text;
    }
  }

  if (!customElements.get('sc-product-gallery')) customElements.define('sc-product-gallery', ScProductGallery);
  if (!customElements.get('sc-product-form')) customElements.define('sc-product-form', ScProductForm);
})();
